/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Trim_Duration_Aria_LabelInputs */

const en_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim event duration`)
};

const fr_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster la duree de l'evenement`)
};

const de_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer des Trim-Ereignisses`)
};

const it_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduci la durata dell'evento`)
};

const ru_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Длительность события обрезки`)
};

const es_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar la duración del evento`)
};

const zh_cn2_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩短事件持续时间`)
};

const ja_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント期間をトリムする`)
};

const hi_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रिम इवेंट अवधि`)
};

const pt_pt2_event_ad_trim_duration_aria_label = /** @type {(inputs: Event_Ad_Trim_Duration_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do evento de corte`)
};

/**
* | output |
* | --- |
* | "Trim event duration" |
*
* @param {Event_Ad_Trim_Duration_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_trim_duration_aria_label = /** @type {((inputs?: Event_Ad_Trim_Duration_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Trim_Duration_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_trim_duration_aria_label(inputs)
	if (locale === "de") return de_event_ad_trim_duration_aria_label(inputs)
	if (locale === "it") return it_event_ad_trim_duration_aria_label(inputs)
	if (locale === "ru") return ru_event_ad_trim_duration_aria_label(inputs)
	if (locale === "es") return es_event_ad_trim_duration_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_trim_duration_aria_label(inputs)
	if (locale === "ja") return ja_event_ad_trim_duration_aria_label(inputs)
	if (locale === "hi") return hi_event_ad_trim_duration_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_trim_duration_aria_label(inputs)
	return en_event_ad_trim_duration_aria_label(inputs)
});